import {array_remove, Worker} from "../util";

export default class OTEPOFCtrl {

  static resolve = {
    pofSource: (OTEService) => OTEService.getPOFSource()
  };

  constructor(OTEService, pofSource, $state){
    this.$state = $state;
    this.OTEService = OTEService;
    this.pofSource = pofSource;
    this.newRequest = {}
    this.requests = [];
    this.sendRequest = Worker(this.sendRequest);
    this.loadPof = Worker(this.loadPof);
    this.loadPof();
    this.selection = {};
  }

  addRequest(){
    this.requests.push({
      om: this.newRequest.om,
      from: new Date(this.newRequest.from.valueOf()),
      to: new Date(this.newRequest.to.valueOf())
    });
    this.newRequest.om = null;
  }

  removeRequest(request){
    array_remove(this.requests, request);
  }

  sendRequest(){
    return this.OTEService.requestPOF(this.requests).then(() => this.requests = []);
  }

  sendRequestEE(){
    return this.OTEService.requestDUFVO(this.requests).then(() => this.requests = []);
  }
  
  loadPof(){
    return this.pofSource.load();
  }

  selectedIds(){
    return Object.keys(this.selection).filter(k => this.selection[k]);
  }

  invoice(){
    this.OTEService.getInvoiceData(this.selectedIds()).then(data => this.data = data);
    //this.$state.go("fakturacia-pof", {pofs: this.selectedIds()});
  }

  confirmDelete(pof){
    if(window.confirm("Naozaj zmazať tento POF?")){
      this.OTEService.deletePOF(pof.id).then(() => this.loadPof());
    }
  }

}


// WEBPACK FOOTER //
// ./src/OTE/OTEPOFCtrl.js